module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6Z2DrCHNUxUywtqwBNKTi7-99ffb5c67e0127af6ce16b961b26ae26.jpg";